module.exports = __webpack_public_path__ + "static/media/logo.4b6dc5c7.png";